export default {
  disclaimer: {
    summary:
      'Bitte beachten Sie, dass es in Ihrer Verantwortung liegt, sicherzustellen, dass alle Währungs- und Steuerangaben für die jeweilige Rechtsordnung korrekt sind.',
    extra:
      'Wir stellen diese Informationen nur zu Ihrer Orientierung bereit und übernehmen keine Verantwortung für die Richtigkeit der Währungs- und/oder Steuerangaben oder für die Zahlung dieser Steuern im Rahmen unserer Produkte. Die hier enthaltenen Informationen zu Währung und Steuern dienen nur zu Informationszwecken.',
    show_more: 'Mehr anzeigen',
    show_less: 'Weniger anzeigen',
  },
  partner_note:
    'Dies sind Ihre Standardwerte auf Partnerebene. Restaurants unter Ihrem Konto übernehmen diese Werte automatisch, sofern sie eine Kategorie nicht individuell überschreiben.',
  section_title: 'Steuersätze für Menüartikel',
  new_category_placeholder: 'Neue Kategorie',
  form: {
    name: {
      label: 'Steuerkategorie',
    },
    default_tax_rate: {
      label: 'Standardsatz',
      tooltip: 'Wird als Fallback verwendet, wenn ein spezifischer Satz für eine Bestellart unten leer bleibt.',
    },
    pickup_tax_rate: {
      label: 'Abholung',
    },
    delivery_tax_rate: {
      label: 'Lieferung',
    },
    dine_in_tax_rate: {
      label: 'Im Restaurant',
    },
    room_service_tax_rate: {
      label: 'Zimmerservice',
    },
    show_zero_tax_in_summary: {
      label: '0%-Steuer in der Bestellübersicht anzeigen',
    },
  },
  buttons: {
    add_category: 'Neue Steuerkategorie hinzufügen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    confirm: 'Löschen',
    delete: 'Kategorie löschen',
    reset: 'Auf geerbte zurücksetzen',
  },
  delete_confirm: {
    title: 'Diese Steuerkategorie löschen?',
    description: 'Dies kann nicht rückgängig gemacht werden.',
  },
  scope_labels: {
    region: 'Regionsweit',
    partner: 'Partnerweit',
    restaurant: 'Restaurantweit',
  },
  confirm_modal: {
    title: {
      fork: 'Als eigene Kategorie dieses Restaurants übernehmen?',
      owned: 'Neue Steuersätze übernehmen?',
      reset: 'Zur geerbten Kategorie zurückkehren?',
    },
    affected_one: '{{count}} Produkt oder Kategorie ist derzeit verknüpft und wird mit den neuen Sätzen berechnet.',
    affected_other:
      '{{count}} Produkte und Kategorien sind derzeit verknüpft und werden mit den neuen Sätzen berechnet.',
    affected_settings_one:
      '{{count}} Produkt oder Kategorie ist derzeit verknüpft und übernimmt die geänderten Einstellungen.',
    affected_settings_other:
      '{{count}} Produkte und Kategorien sind derzeit verknüpft und übernehmen die geänderten Einstellungen.',
    restaurants_one: 'Das betrifft {{count}} Restaurant.',
    restaurants_other: 'Das betrifft {{count}} Restaurants.',
    acknowledge:
      'Mir ist bewusst, dass diese Bestätigung die Steuerkategorie aller Produkte ändert, die derzeit mit dieser Kategorie verknüpft sind',
    impact_error: 'Es konnte nicht geprüft werden, welche Produkte dies ändern würde',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
  },
  toasts: {
    load_error: 'Die Steuerkategorien konnten nicht geladen werden.',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
    delete_error: 'Diese Steuerkategorie konnte nicht gelöscht werden.',
    category_deleted: 'Steuerkategorie gelöscht',
    category_reset: 'Steuerkategorie auf die geerbte zurückgesetzt',
    reset_error: 'Diese Steuerkategorie konnte nicht zurückgesetzt werden.',
    impact_error: 'Es konnte nicht geprüft werden, welche Produkte dies ändern würde',
    impact_changed_one:
      'Die Anzahl der betroffenen Produkte hat sich auf {{count}} geändert. Bitte prüfen und erneut bestätigen.',
    impact_changed_other:
      'Die Anzahl der betroffenen Produkte hat sich auf {{count}} geändert. Bitte prüfen und erneut bestätigen.',
  },
};
